import { action, createAction } from 'typesafe-actions'

import { Organization } from 'src/types'

import { OrganizationsActionTypes } from './types'

export const getOrganizations = createAction(
  OrganizationsActionTypes.GET_ORGANIZATIONS,
  action => () => action()
)

export const getOrganizationsFailure = () =>
  action(OrganizationsActionTypes.GET_ORGANIZATIONS_FAILURE)

export const getOrganizationsSuccess = (organizations: Organization[]) =>
  action(OrganizationsActionTypes.GET_ORGANIZATIONS_SUCCESS, { organizations })
